"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactStripeElements = require("react-stripe-elements");

var _StripeContext = _interopRequireDefault(require("./StripeContext"));

var _useWindowStripe = _interopRequireDefault(require("./useWindowStripe"));

var ComponenentWithStripe = (0, _reactStripeElements.injectStripe)(function (_ref) {
  var stripe = _ref.stripe,
      children = _ref.children;
  return children(stripe);
});

var _default = function _default(_ref2) {
  var children = _ref2.children,
      apiKey = _ref2.apiKey;
  var stripe = (0, _useWindowStripe["default"])(apiKey);
  return /*#__PURE__*/_react["default"].createElement(_reactStripeElements.StripeProvider, {
    stripe: stripe
  }, /*#__PURE__*/_react["default"].createElement(_reactStripeElements.Elements, null, /*#__PURE__*/_react["default"].createElement(ComponenentWithStripe, null, function (extendedStripe) {
    return /*#__PURE__*/_react["default"].createElement(_StripeContext["default"].Provider, {
      value: extendedStripe
    }, children);
  })));
};

exports["default"] = _default;